import { render, staticRenderFns } from "./kanban-list.vue?vue&type=template&id=56f1670d&scoped=true&"
import script from "./kanban-list.vue?vue&type=script&lang=js&"
export * from "./kanban-list.vue?vue&type=script&lang=js&"
import style0 from "./kanban-list.vue?vue&type=style&index=0&id=56f1670d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1670d",
  null
  
)

export default component.exports